import { render } from "./TheMultiselect.vue?vue&type=template&id=889f0888&scoped=true"
import script from "./TheMultiselect.vue?vue&type=script&lang=js"
export * from "./TheMultiselect.vue?vue&type=script&lang=js"

import "./TheMultiselect.vue?vue&type=style&index=0&id=889f0888&lang=css"
import "./TheMultiselect.vue?vue&type=style&index=1&id=889f0888&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889f0888"]])

export default __exports__